import { gameState } from '../services/gameState.js';
import { sound } from '../services/audioService.js';

export class TimeWarpToolbar {
  constructor(containerElement, toastElement) {
    this.container = containerElement;
    this.toastEl = toastElement;
    this.isOpen = false;
    this.init();
  }

  init() {
    this.render();
  }

  showToast(message) {
    if (!this.toastEl) return;
    this.toastEl.textContent = message;
    this.toastEl.classList.add('visible');
    setTimeout(() => {
      this.toastEl.classList.remove('visible');
    }, 2400);
  }

  render() {
    this.container.innerHTML = `
      <div class="timewarp-sheet">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-size: 16px; font-weight: 800;">⏱️ Dev Time-Warp & Mood Tester</div>
          <button class="close-btn" id="close-warp-btn">✕</button>
        </div>
        <div style="font-size: 11px; color: var(--text-muted);">
          Simulate offline real-world time passing to test stat decay and instant mood states:
        </div>

        <div style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: #6C5CE7; margin-top: 4px;">Time Simulator</div>
        <div class="warp-grid">
          <button class="warp-btn" data-warp="1">Fast-Forward +1 Hour</button>
          <button class="warp-btn" data-warp="4">Fast-Forward +4 Hours</button>
          <button class="warp-btn" data-warp="12">Fast-Forward +12 Hours</button>
          <button class="warp-btn" id="toggle-fast-decay">⚡ 10s Fast Decay: OFF</button>
        </div>

        <div style="font-size: 11px; font-weight: 700; text-transform: uppercase; color: #6C5CE7; margin-top: 4px;">Instant Mood Presets</div>
        <div class="warp-grid">
          <button class="warp-btn" style="border-color: #FFD700;" data-preset="happy">✨ Happy (> 80%)</button>
          <button class="warp-btn" style="border-color: #00E676;" data-preset="serene">🌿 Serene (65%)</button>
          <button class="warp-btn" style="border-color: #2979FF;" data-preset="sad">💧 Sad (35%)</button>
          <button class="warp-btn" style="border-color: #FF1744;" data-preset="mad">🔥 Mad (10%)</button>
        </div>

        <div style="display: flex; gap: 8px; margin-top: 4px;">
          <button class="warp-btn" style="flex: 1; background: rgba(0, 230, 118, 0.15); border-color: #00E676;" id="refill-all-btn">⚡ Refill All (9/9)</button>
          <button class="warp-btn" style="flex: 1; background: rgba(255, 23, 68, 0.15); border-color: #FF1744;" id="drain-all-btn">⚠️ Drain All (0/9)</button>
        </div>
      </div>
    `;

    // Event Listeners
    this.container.querySelector('#close-warp-btn').addEventListener('click', () => {
      sound.playClick();
      this.close();
    });

    // Time warp buttons
    this.container.querySelectorAll('[data-warp]').forEach((btn) => {
      btn.addEventListener('click', () => {
        sound.playClick();
        const hours = parseInt(btn.getAttribute('data-warp'), 10);
        gameState.timeWarp(hours);
        this.showToast(`⏩ Simulated +${hours} hour(s) offline!`);
      });
    });

    // Mood preset buttons
    this.container.querySelectorAll('[data-preset]').forEach((btn) => {
      btn.addEventListener('click', () => {
        sound.playClick();
        const preset = btn.getAttribute('data-preset');
        if (preset === 'happy') {
          gameState.drainToAverage(95);
          this.showToast('✨ Mood set to HAPPY (>80%)');
        } else if (preset === 'serene') {
          gameState.drainToAverage(65);
          this.showToast('🌿 Mood set to SERENE (50-80%)');
        } else if (preset === 'sad') {
          gameState.drainToAverage(35);
          this.showToast('💧 Mood set to SAD (20-50%)');
        } else if (preset === 'mad') {
          gameState.drainToAverage(10);
          this.showToast('🔥 Mood set to MAD (<20%)');
        }
      });
    });

    // Fast decay toggle
    const fastDecayBtn = this.container.querySelector('#toggle-fast-decay');
    fastDecayBtn.addEventListener('click', () => {
      sound.playClick();
      const isActive = gameState.toggleFastDecay();
      fastDecayBtn.textContent = `⚡ 10s Fast Decay: ${isActive ? 'ON' : 'OFF'}`;
      fastDecayBtn.classList.toggle('active', isActive);
      this.showToast(`Fast decay mode: ${isActive ? 'ACTIVATED' : 'DEACTIVATED'}`);
    });

    // Refill / Drain
    this.container.querySelector('#refill-all-btn').addEventListener('click', () => {
      sound.playClick();
      gameState.fillAllStats();
      this.showToast('🌟 All stats refilled to 9/9!');
    });

    this.container.querySelector('#drain-all-btn').addEventListener('click', () => {
      sound.playClick();
      gameState.drainToAverage(0);
      this.showToast('⚠️ All stats drained to 0/9!');
    });
  }

  open() {
    this.isOpen = true;
    this.container.classList.add('active');
  }

  close() {
    this.isOpen = false;
    this.container.classList.remove('active');
  }
}
